/***
 *
 *   LOGO
 *   Replace the image in /images with your own logo
 *
 **********/

import { ClassHelper, Link } from "components/lib";
import {
  default as LogoColor,
  default as LogoWhite,
} from "./images/DefaultLogo.png";
import {
  default as LogoMarkColor,
  default as LogoMarkWhite,
} from "./images/SmallLogo.png";
import Style from "./styles.module.scss";

export function Logo(props) {
  const Logo = {
    color: {
      logo: LogoColor,
      mark: LogoMarkColor,
    },
    white: {
      logo: LogoWhite,
      mark: LogoMarkWhite,
    },
  };

  const logoStyle = ClassHelper(Style, props);

  return (
    <Link url="/" className={logoStyle}>
      <img
        src={
          Logo[props.color ? "color" : "white"][props.mark ? "mark" : "logo"]
        }
        alt="Logo"
      />
    </Link>
  );
}
